import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { AppState } from '../app.state';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { TrainingService } from '../../services/training.service';
import * as actions from './actions';
import { StatusHelper } from '../../helpers/statuses-helper';
import { AlertService } from '../../services/alert.service';
import { switchMap, catchError, map } from 'rxjs/operators';

@Injectable()
export class TrainingEffects {
  constructor(
    protected store: Store<AppState>,
    protected service: TrainingService,
    protected action$: Actions,
    private alertService: AlertService
  ) { }

  GetTrainingEvents$ = createEffect(() => this.action$.pipe(
    ofType<actions.GetTrainingEventsAction>(actions.GET_TRAINING_EVENTS),
    switchMap(action => this.service.getTrainingEvents(action.userRole).pipe(
      map((result) => new actions.GetTrainingEventsSuccessAction(result)),
      catchError(error => {
        this.alertService.error(error);
        return of(new actions.GetTrainingEventsErrorAction(error));
      })))));

  CreateTrainigEvent$ = createEffect(() => this.action$.pipe(
    ofType<actions.CreateTrainingEventAction>(actions.CREATE_TRAINING_EVENT),
    switchMap(action => this.service.createEvent(action.payload).pipe(
      map((result) => {
        const message = `Training event created, status: ${StatusHelper.getStatusText(result.status)}`;
        this.alertService.success(message);
        return new actions.CreateTrainingEventSuccessAction(result);
      }),
      catchError(error => {
        this.alertService.error(error);
        return of(new actions.CreateTrainingEventErrorAction(error));
      })))));

  GetTrainingEventById$ = createEffect(() => this.action$.pipe(
    ofType<actions.GetTrainingEventByIdAction>(actions.GET_TRAINING_EVENT_BY_ID),
    switchMap(action => this.service.getEventById(action.id).pipe(
      map((result) => new actions.GetTrainingEventByIdSuccessAction(result)),
      catchError(error => {
        this.alertService.error(error);
        return of(new actions.GetTrainingEventByIdErrorAction(error));
      })))));

  UpdateTrainigEvent$ = createEffect(() => this.action$.pipe(
    ofType<actions.UpdateTrainingEventAction>(actions.UPDATE_TRAINING_EVENT),
    switchMap(action => this.service.updateEvent(action.payload).pipe(
      map((result) => {
        const message = `Training event updated, status: ${StatusHelper.getStatusText(result.status)}`;
        this.alertService.success(message);
        return new actions.UpdateTrainingEventSuccessAction(result);
      }),
      catchError(error => {
        this.alertService.error(error);
        return of(new actions.UpdateTrainingEventErrorAction(error));
      })))));

  GetTrainingParticipants$ = createEffect(() => this.action$.pipe(
    ofType<actions.GetTrainingParticipantsAction>(actions.GET_TRAINING_PARTICIPANTS),
    switchMap(action => this.service.getParticipants().pipe(
      map((result) => new actions.GetTrainingParticipantsSuccessAction(result)),
      catchError(error => {
        this.alertService.error(error);
        return of(new actions.GetTrainingParticipantsErrorAction(error));
      })))));

  GetTrainingParticipantsByCompany$ = createEffect(() => this.action$.pipe(
    ofType<actions.GetTrainingParticipantByCompanyAction>(actions.GET_TRAINING_PARTICIPANTS_BY_COMPANY),
    switchMap(action => this.service.getParticipantsByCompany(action.payload).pipe(
      map((result) => new actions.GetTrainingParticipantsSuccessAction(result)),
      catchError(error => {
        this.alertService.error(error);
        return of(new actions.GetTrainingParticipantsErrorAction(error));
      })))));

  CreateTrainingParticipant$ = createEffect(() => this.action$.pipe(
    ofType<actions.CreateTrainingParticipantAction>(actions.CREATE_TRAINING_PARTICIPANT),
    switchMap(action => this.service.createParticipant(action.payload).pipe(
      map((result) => new actions.CreateTrainingParticipantSuccessAction(result)),
      catchError(error => {
        this.alertService.error(error);
        return of(new actions.CreateTrainingParticipantErrorAction(error));
      })))));

  CreateTrainingRequest$ = createEffect(() => this.action$.pipe(
    ofType<actions.CreateTrainingRequestAction>(actions.CREATE_TRAINING_REQUEST),
    switchMap(action => this.service.createRequest(action.payload).pipe(
      map(result => new actions.CreateTrainingRequestSuccessAction(result)),
      catchError(error => {
        this.alertService.error(error);
        return of(new actions.CreateTrainingRequestErrorAction(error));
      })))));

  UpdateTrainingRequest$ = createEffect(() => this.action$.pipe(
    ofType<actions.UpdateTrainingRequestAction>(actions.UPDATE_TRAINING_REQUEST),
    switchMap(action => this.service.updateRequest(action.payload).pipe(
      map(result => new actions.UpdateTrainingRequestSuccessAction(result)),
      catchError(error => {
        this.alertService.error(error);
        return of(new actions.UpdateTrainingRequestErrorAction(error));
      })))));
}
